define.alias("shared/utils/array-filters/get-last-value", "preview-grid/utils/array-filters/get-last-value");